import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-star-seller',
  standalone: true,
  templateUrl: '../../assets/star-seller.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamStarSellerIcon {}
